import { ROLES } from "../constants/base";

// Who works as the cellarman of an operation. Data scoping, not permission gating: a winery with no account of
// type USER has no cellarman, so its CLIENT confirms the operations (and assigns the drug batches) as a USER would.

export const hasCellarmen = (users) => (users || []).some((u) => u?.type === "USER");

export const isClientWithoutCellarmen = (role, users) => role === ROLES.CLIENT && !hasCellarmen(users);

export const actsAsCellarman = (role, users) => role === ROLES.USER || isClientWithoutCellarmen(role, users);

// Who sees what the products of an operation cost: the client, or the USER of a winery with no cellarman.
// Pending a COSTS resource (none exists yet): until then it stays a data-scoping rule on the account type.
export const canSeeCosts = (role, users) => role === ROLES.CLIENT || (role === ROLES.USER && !hasCellarmen(users));
